/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import * as com_amazon_coral_availability from "@amzn/coral_com-amazon-coral-availability";
import * as com_amazon_coral_service_bsf from "@amzn/coral_com-amazon-coral-service-bsf";
import * as com_amazon_coral_service from "@amzn/coral_com-amazon-coral-service";
import * as com_amazon_coral_client from "@amzn/coral_com-amazon-coral-client";
import { AcceptInvitationResponse } from "./AcceptInvitationResponse";
import { ConfirmInvitationResponse } from "./ConfirmInvitationResponse";
import { DeactivateUserResponse } from "./DeactivateUserResponse";
import { ResendInvitationResponse } from "./ResendInvitationResponse";
import { GetInvitationRequest } from "./GetInvitationRequest";
import { UserAuthInput } from "./UserAuthInput";
import { GetUsersForLogisticsPartyRequest } from "./GetUsersForLogisticsPartyRequest";
import { DeleteInvitationRequest } from "./DeleteInvitationRequest";
import { GetInvitedUsersForLogisticsPartyRequest } from "./GetInvitedUsersForLogisticsPartyRequest";
import { UpdateUserProfileInfoRequest } from "./UpdateUserProfileInfoRequest";
import { CreateInvitationResponse } from "./CreateInvitationResponse";
import { GetUsersForLogisticsPartyResponse } from "./GetUsersForLogisticsPartyResponse";
import { GetDeactivatedUsersResponse } from "./GetDeactivatedUsersResponse";
import { GetUserProfileInfoResponse } from "./GetUserProfileInfoResponse";
import { PUMSUnAuthorizedException } from "./PUMSUnAuthorizedException";
import { GetDeactivatedUsersRequest } from "./GetDeactivatedUsersRequest";
import { ConfirmInvitationRequest } from "./ConfirmInvitationRequest";
import { DeactivateUserRequest } from "./DeactivateUserRequest";
import { GetRequestedUserProfileInfoResponse } from "./GetRequestedUserProfileInfoResponse";
import { PUMSInvalidRequestException } from "./PUMSInvalidRequestException";
import { ResendInvitationRequest } from "./ResendInvitationRequest";
import { CreateInvitationRequest } from "./CreateInvitationRequest";
import { DeleteInvitationResponse } from "./DeleteInvitationResponse";
import { GetAnalyticsMetricsRequest } from "./GetAnalyticsMetricsRequest";
import { AcceptInvitationRequest } from "./AcceptInvitationRequest";
import { GetUserProfileInfoRequest } from "./GetUserProfileInfoRequest";
import { GetInvitedUsersForLogisticsPartyResponse } from "./GetInvitedUsersForLogisticsPartyResponse";
import { GetRequestedUserProfileInfoRequest } from "./GetRequestedUserProfileInfoRequest";
import { PUMSRecoverableException } from "./PUMSRecoverableException";
import { GetAnalyticsMetricsResponse } from "./GetAnalyticsMetricsResponse";
import { UpdateUserProfileInfoResponse } from "./UpdateUserProfileInfoResponse";
import { UserAuthOutput } from "./UserAuthOutput";
import { GetInvitationResponse } from "./GetInvitationResponse";
import { PUMSUnrecoverableException } from "./PUMSUnrecoverableException";
import * as com_amazon_coral_validate from "@amzn/coral_com-amazon-coral-validate";
import * as com_amazon_coral_service_jms from "@amzn/coral_com-amazon-coral-service-jms";
import * as com_amazon_coral_service_http from "@amzn/coral_com-amazon-coral-service-http";
import { CoralClient, CoralResponse, } from "@amzn/ihm-js-coral-client";
import { CoralClientHttpBindingInterceptor, CoralClientSerdesInterceptor, InterceptingHandler, } from "@amzn/ihm-js-coral-client";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
export const passportUserManagementServiceSerdesInterceptor = new CoralClientSerdesInterceptor({
    AcceptInvitation: {
        deserializationFn: AcceptInvitationResponse.fromJson,
        serializationFn: AcceptInvitationRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    ConfirmInvitation: {
        deserializationFn: ConfirmInvitationResponse.fromJson,
        serializationFn: ConfirmInvitationRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    CreateInvitation: {
        deserializationFn: CreateInvitationResponse.fromJson,
        serializationFn: CreateInvitationRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    DeactivateUser: {
        deserializationFn: DeactivateUserResponse.fromJson,
        serializationFn: DeactivateUserRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    DeleteInvitation: {
        deserializationFn: DeleteInvitationResponse.fromJson,
        serializationFn: DeleteInvitationRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetAnalyticsMetrics: {
        deserializationFn: GetAnalyticsMetricsResponse.fromJson,
        serializationFn: GetAnalyticsMetricsRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetDeactivatedUsers: {
        deserializationFn: GetDeactivatedUsersResponse.fromJson,
        serializationFn: GetDeactivatedUsersRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetInvitation: {
        deserializationFn: GetInvitationResponse.fromJson,
        serializationFn: GetInvitationRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetInvitedUsersForLogisticsParty: {
        deserializationFn: GetInvitedUsersForLogisticsPartyResponse.fromJson,
        serializationFn: GetInvitedUsersForLogisticsPartyRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetRequestedUserProfileInfo: {
        deserializationFn: GetRequestedUserProfileInfoResponse.fromJson,
        serializationFn: GetRequestedUserProfileInfoRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetUserProfileInfo: {
        deserializationFn: GetUserProfileInfoResponse.fromJson,
        serializationFn: GetUserProfileInfoRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    GetUsersForLogisticsParty: {
        deserializationFn: GetUsersForLogisticsPartyResponse.fromJson,
        serializationFn: GetUsersForLogisticsPartyRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    ResendInvitation: {
        deserializationFn: ResendInvitationResponse.fromJson,
        serializationFn: ResendInvitationRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    UpdateUserProfileInfo: {
        deserializationFn: UpdateUserProfileInfoResponse.fromJson,
        serializationFn: UpdateUserProfileInfoRequest.toJson,
        modelledExceptions: [
            PUMSUnAuthorizedException,
            PUMSUnrecoverableException,
            PUMSInvalidRequestException,
            PUMSRecoverableException,
        ],
    },
    UserAuth: {
        deserializationFn: UserAuthOutput.fromJson,
        serializationFn: UserAuthInput.toJson,
        modelledExceptions: [],
    },
}, [
    com_amazon_coral_availability.BackOffException,
    com_amazon_coral_availability.ThrottlingException,
    com_amazon_coral_client.ClientUnavailableException,
    com_amazon_coral_client.HttpConnectionTimeoutException,
    com_amazon_coral_client.HttpFailureException,
    com_amazon_coral_client.HttpTimeoutException,
    com_amazon_coral_service_bsf.InvalidCodigoMessageException,
    com_amazon_coral_service_http.HeaderMisclassificationException,
    com_amazon_coral_service_http.HttpNotFoundException,
    com_amazon_coral_service_http.InvalidAuthSchemeException,
    com_amazon_coral_service_http.InvalidAuthSchemeParameterException,
    com_amazon_coral_service_http.InvalidMessageDigestException,
    com_amazon_coral_service_http.MissingAuthSchemeParameterException,
    com_amazon_coral_service_http.MissingMessageDigestException,
    com_amazon_coral_service_http.MissingRequiredHeaderException,
    com_amazon_coral_service_jms.MessageProcessingException,
    com_amazon_coral_service_jms.MessagePublishException,
    com_amazon_coral_service.AccessDeniedException,
    com_amazon_coral_service.DelegationException,
    com_amazon_coral_service.ExpiredTokenException,
    com_amazon_coral_service.IncompleteSignatureException,
    com_amazon_coral_service.InternalFailure,
    com_amazon_coral_service.InvalidAwsQueryStringException,
    com_amazon_coral_service.InvalidParameterCombinationException,
    com_amazon_coral_service.InvalidParameterValueException,
    com_amazon_coral_service.InvalidQueryParameterException,
    com_amazon_coral_service.InvalidQueryStringException,
    com_amazon_coral_service.InvalidSignatureException,
    com_amazon_coral_service.MalformedHttpRequestException,
    com_amazon_coral_service.MissingActionException,
    com_amazon_coral_service.MissingAuthenticationTokenException,
    com_amazon_coral_service.MissingRequiredParameterException,
    com_amazon_coral_service.NotAuthorizedException,
    com_amazon_coral_service.RequestAbortedException,
    com_amazon_coral_service.RequestEntityTooLargeException,
    com_amazon_coral_service.RequestExpiredException,
    com_amazon_coral_service.RequestTimeoutException,
    com_amazon_coral_service.SerializationException,
    com_amazon_coral_service.ServiceUnavailableException,
    com_amazon_coral_service.SubscriptionRequiredException,
    com_amazon_coral_service.TimeoutException,
    com_amazon_coral_service.TransmutationException,
    com_amazon_coral_service.UnknownOperationException,
    com_amazon_coral_service.UnrecognizedClientException,
    com_amazon_coral_service.UnsupportedMediaTypeException,
    com_amazon_coral_validate.ValidationException,
]);
export const passportUserManagementServiceHttpBindingInterceptor = new CoralClientHttpBindingInterceptor({
    AcceptInvitation: {
        method: "POST",
        path: "/invites/acceptances/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId",
        },
    },
    ConfirmInvitation: {
        method: "POST",
        path: "/invitations/confirmations/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId",
        },
    },
    CreateInvitation: {
        method: "POST",
        path: "/invitations",
    },
    DeactivateUser: {
        method: "DELETE",
        path: "/user/deactivate",
    },
    DeleteInvitation: {
        method: "DELETE",
        path: "/invitations/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId",
        },
    },
    GetAnalyticsMetrics: {
        method: "GET",
        path: "/pums/metrics",
    },
    GetDeactivatedUsers: {
        method: "POST",
        path: "/users/deactivated?fetchInternalUsers={fetchInternalUsers}",
        labelTransformations: {
            fetchInternalUsers: "fetchInternalUsers",
        },
    },
    GetInvitation: {
        method: "GET",
        path: "/invitations/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId",
        },
    },
    GetInvitedUsersForLogisticsParty: {
        method: "POST",
        path: "/lps/invitees",
    },
    GetRequestedUserProfileInfo: {
        method: "POST",
        path: "/user/authorized",
    },
    GetUserProfileInfo: {
        method: "GET",
        path: "/user",
    },
    GetUsersForLogisticsParty: {
        method: "POST",
        path: "/lps/users?fetchInternalUsers={fetchInternalUsers}",
        labelTransformations: {
            fetchInternalUsers: "fetchInternalUsers",
        },
    },
    ResendInvitation: {
        method: "POST",
        path: "/invitations/resends/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId",
        },
    },
    UpdateUserProfileInfo: {
        method: "POST",
        path: "/user?mons_sel_locale={monsSelectLocale}",
        labelTransformations: {
            monsSelectLocale: "monsSelectLocale",
        },
    },
    UserAuth: {
        method: "GET",
        path: "/user/auth?origin={origin}",
        labelTransformations: {
            origin: "origin",
        },
    },
});
/**
 * This service is to allow registration of new Logistics Party’s users onto passport as well as mange their profile
 * information.
 * This service will also be responsible for sending the invite to external Logistics Party’s users.
 * For more info:
 * https:\/\/w.amazon.com\/bin\/view\/Transportation\/Passport\/PassportCoreServices\/PassportUserManagement\/
 **/
export class PassportUserManagementService extends CoralClient {
    constructor(config, handler) {
        const serdesHandler = new InterceptingHandler(handler, [
            passportUserManagementServiceSerdesInterceptor,
        ]);
        super(config, serdesHandler);
    }
    /**
     * Accepts an invitation. This gives a user a basic set of rights on the passport platform for the logistics
     * party(com.amazon.trans.agreement.v1#LogisticsParty) specified in the invitation.
     * If the accepted user's contact information doesn't match with the contact information specified in the invite
     * then the invite will be marked as pending for manual approval.
     **/
    acceptInvitation(request) {
        return super.call("AcceptInvitation", request).pipe(map(({ body }) => {
            if (!(body instanceof AcceptInvitationResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type AcceptInvitationResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Approves an accepted invitation for a specific user to become a LogisticsParty's
     * (com.amazon.trans.agreement.v1#LogisticsParty) user on the passport platform.
     **/
    confirmInvitation(request) {
        return super.call("ConfirmInvitation", request).pipe(map(({ body }) => {
            if (!(body instanceof ConfirmInvitationResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type ConfirmInvitationResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Creates an invitation to become a LogisticsParty's (com.amazon.trans.agreement.v1#LogisticsParty)
     * user on the passport platform. This will send a notification to the invited user on the specified channel.
     **/
    createInvitation(request) {
        return super.call("CreateInvitation", request).pipe(map(({ body }) => {
            if (!(body instanceof CreateInvitationResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type CreateInvitationResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * API for deactivating an existing user from the carrierlogistics platform. Usually admin for a LP can
     * deactivate another non-Admin user from the platform.
     **/
    deactivateUser(request) {
        return super.call("DeactivateUser", request).pipe(map(({ body }) => {
            if (!(body instanceof DeactivateUserResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type DeactivateUserResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Revokes an invitation, making it unusable for the previously invited customer.
     * This API will be used by the inviting customer to decline the invitation.
     **/
    deleteInvitation(request) {
        return super.call("DeleteInvitation", request).pipe(map(({ body }) => {
            if (!(body instanceof DeleteInvitationResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type DeleteInvitationResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Operational API to return analytics metrics for all the externalized Logistics Parties.
     **/
    getAnalyticsMetrics(request) {
        return super.call("GetAnalyticsMetrics", request).pipe(map(({ body }) => {
            if (!(body instanceof GetAnalyticsMetricsResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetAnalyticsMetricsResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Returns a list of deactivated users on the platform.
     **/
    getDeactivatedUsers(request) {
        return super.call("GetDeactivatedUsers", request).pipe(map(({ body }) => {
            if (!(body instanceof GetDeactivatedUsersResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetDeactivatedUsersResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Returns a single invitation for a given invitation id.
     **/
    getInvitation(request) {
        return super.call("GetInvitation", request).pipe(map(({ body }) => {
            if (!(body instanceof GetInvitationResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetInvitationResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Returns a list of all invited customers invited for a Logistics party(com.amazon.trans.agreement.v1#LogisticsParty)
     **/
    getInvitedUsersForLogisticsParty(request) {
        return super.call("GetInvitedUsersForLogisticsParty", request).pipe(map(({ body }) => {
            if (!(body instanceof GetInvitedUsersForLogisticsPartyResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetInvitedUsersForLogisticsPartyResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Returns user profile information of requested user.
     **/
    getRequestedUserProfileInfo(request) {
        return super.call("GetRequestedUserProfileInfo", request).pipe(map(({ body }) => {
            if (!(body instanceof GetRequestedUserProfileInfoResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetRequestedUserProfileInfoResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Returns user profile information for a given user identifier.
     **/
    getUserProfileInfo(request) {
        return super.call("GetUserProfileInfo", request).pipe(map(({ body }) => {
            if (!(body instanceof GetUserProfileInfoResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetUserProfileInfoResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Return a list of verified users for the Logistics party(com.amazon.trans.agreement.v1#LogisticsParty).
     **/
    getUsersForLogisticsParty(request) {
        return super.call("GetUsersForLogisticsParty", request).pipe(map(({ body }) => {
            if (!(body instanceof GetUsersForLogisticsPartyResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetUsersForLogisticsPartyResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * For an existing invitation, sends a new notification to an invited customer.
     **/
    resendInvitation(request) {
        return super.call("ResendInvitation", request).pipe(map(({ body }) => {
            if (!(body instanceof ResendInvitationResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type ResendInvitationResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Updates user profile information.
     **/
    updateUserProfileInfo(request) {
        return super.call("UpdateUserProfileInfo", request).pipe(map(({ body }) => {
            if (!(body instanceof UpdateUserProfileInfoResponse)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type UpdateUserProfileInfoResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * API takes client origin as input and then gives a redirection
     **/
    userAuth(request) {
        return super.call("UserAuth", request).pipe(map(({ body }) => {
            if (!(body instanceof UserAuthOutput)) {
                throw new TypeError(`[PassportUserManagementService] Expected response body to be of type UserAuthOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
}
PassportUserManagementService.assembly = "com.amazon.passportusermanagementservice";
PassportUserManagementService.serviceName = "PassportUserManagementService";
